import { LOAD_IMAGEN_VIDEO_PROTECTORA } from '../../AnimalList/actions/actionsAnimalList'
import { SHOW_IMAGEN_VIDEO_PROTECTORA } from '../../AnimalList/actions/actionsAnimalList'
import {reducerAnimalList} from "../../AnimalList/reducers/reducerAnimalList";


const initialState = {
	galeria_imagenes: [],
    galeria_videos: [],
	show: false,
	load: false
};

export function reducerAnimalDetailProtectoraImagenYVideo(state = initialState, action) {

	switch (action.type) {
		case LOAD_IMAGEN_VIDEO_PROTECTORA:
			return Object.assign({}, state, {
                galeria_imagenes: action.payload.galeria_imagenes,
                galeria_videos: action.payload.galeria_videos,
				load: true
			});
        case SHOW_IMAGEN_VIDEO_PROTECTORA:
            return Object.assign({}, state, {
                show: action.payload.show
            });
		default:
			return state
	}
}